export const app = {
  state: {
    ready: false,
  },
  mutations: {
    updateAppStatus(state, isReady = false) {
      state.ready = isReady
    },
  },
  actions: {
    async initApp(context, { clothing, clothingTypes }) {
      await context.dispatch('setClothing', clothing)
      await context.dispatch('setClothingTypes', clothingTypes)
      context.commit('updateAppStatus', true)
    },
    updateAppStatus(context, isReady = false) {
      context.commit('updateAppStatus', isReady)
    },
  },
}
